import React from 'react';
import { Image, Platform, StyleSheet, View } from 'react-native';
import PropTypes from 'prop-types';

const CdnImage = props => {
    const initialUri = props.uri?.startsWith('http') ? props.uri : `https:${props.uri}`;
    const uri = !props.width ? initialUri : `${initialUri}?width=${props.width}`;

    if (Platform.OS === 'web') {
        return (
            <div style={props.omitWrapperStyle ? {} : StyleSheet.flatten(props.wrapperStyle, { width: props.width })}>
                <img src={uri} style={{ ...Styles.image, ...props.style }} />
            </div>
        );
    } else {
        return (
            <View style={props.omitWrapperStyle ? {} : StyleSheet.flatten(props.wrapperStyle)}>
                <Image source={{ uri }} width={props.width} height={props.height || Math.floor(props.width / 2)} style={props.style} />
            </View>
        );
    }
};

const Styles = StyleSheet.create({
    image: {
        height: '100%',
        width: '100%'
    }
});

CdnImage.propTypes = {
    omitWrapperStyle: PropTypes.bool,
    uri: PropTypes.string,
    style: PropTypes.object,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    wrapperStyle: PropTypes.object
};

export default CdnImage;
